import React, { useEffect, useState } from 'react';

const ChannelAdminReviewArticlesModal = ({notifications, currentUserId, handleModalClose}) => {

  const [channels, setChannels] = useState(notifications);

  const updateNotification = (notification) => {
    $.ajax({
      type: 'put',
      url: `/users/${currentUserId}/notifications/${notification.id}/update_notification`,
      success: function(res) {
        handleModalClose(notifications);
        window.location.href = `${notification.url}/${notification.channel_id}#!/articles`
      }
    })
  }


  const renderPluralization = () => {
    if (notifications.length === 1) {
      return `${notifications.length} article ready for review.`;
    } else {
      return `${notifications.length} articles ready for review.`;
    }
  }

  return (
    <div data-reveal className='reveal-modal' id='channel-admin-review-alert-modal'>
      <div className='modal-body'>
        <div className='modal-close'>
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
      </div>
      <div className='modal-content'>
        <div className='image'>
          <img src="https://public.cureus.com/bell-alerts/guest-editor-alert-modal.png" />
        </div>
        <h4 className='title'>{notifications[0].title}</h4>
        <div className='message'>
          <p>{renderPluralization()}</p>
        </div>
        <a className='button primary' onClick={()=> updateNotification(notifications[0])}>View Dashboard</a>
      </div>
    </div>
  )
}

export default ChannelAdminReviewArticlesModal;